import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Por qué el precio es tan bajo?',
    answer: 'Es un precio de lanzamiento. Mi objetivo es que la mayor cantidad de profesionales del turismo puedan acceder a esta información y empezar a ver resultados rápidos. El precio subirá pronto.'
  }, {
    question: '¿Funciona si recién empiezo?',
    answer: 'Sí, de hecho es el mejor momento para leerlo. Te ahorrarás meses de frustración aprendiendo desde el día uno cómo estructurar tus cotizaciones correctamente.'
  }, {
    question: '¿Cuándo puedo empezar a aplicar esto?',
    answer: 'Inmediatamente. El E-book y las plantillas están diseñados para que los leas hoy y los uses en tu próxima cotización.'
  }, {
    question: '¿Sirve para manejar objeciones?',
    answer: 'Totalmente. El bono "Guía de objeciones" incluye respuestas para las excusas más comunes como "es muy caro" o "lo voy a pensar".'
  }];
  return <section className="bg-cream text-navy py-24 px-5" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-4" data-id="element-40">
            Preguntas Frecuentes
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto" data-id="element-41"></div>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-43" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gold/20 rounded bg-white overflow-hidden" data-id="element-44">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-45">
        <span className="font-playfair font-bold text-lg text-navy" data-id="element-46">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-47" />
      </button>
      <AnimatePresence data-id="element-48">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-49">
            <div className="px-6 pb-5 pt-0 font-dmsans text-navy/70 leading-relaxed" data-id="element-50">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}